module.exports = __webpack_public_path__ + "media/flags/pf-0fcfd580.svg";